<template>
  <div class="address">
    <XR-head titleText="收货地址" :rightShow="false" ref="headObj"></XR-head>
    <div class="address-list" v-if="!loaded">
      <div class="address-item" v-for="addressItem in addressList" :key="addressItem.Id">
        <div class="address-info">
          <div class="user">
            <p class="name">{{addressItem.Receiver}}</p>
            <p class="phone">{{addressItem.Phone}}</p>
            <p class="isDefault" v-if="addressItem.Defaultbs>0">默认地址</p>
          </div>
          <div class="addr">{{addressItem.DetailAddress}}</div>
        </div>
        <mu-divider/>
        <div class="address-operator">
          <mu-raised-button label="设置默认" class="btn-dele-address" @click="setDefault(addressItem.Id)" v-if="addressItem.Defaultbs<=0" secondary/>
          <mu-raised-button label="编 辑" class="btn-edit-address" @click="edit(addressItem.Id)" secondary/>
          <mu-raised-button label="删 除" class="btn-dele-address" @click="dele(addressItem.Id)" secondary/>
        </div>
      </div>
    </div>    
    <mu-float-button icon=":fa fa-jiahao" v-if="addressList.length<8" @click="goTo('/usercenter/addressedit')" class="btn-address-add" primary />
    <mu-dialog :open="dialog" title="确定要删除吗" @close="close">      
      <mu-flat-button slot="actions" @click="close" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="deleAddress()" label="确定"/>
    </mu-dialog>
    <XR-toast @onClose="setDefaulSuccess" ref="XRtoast"></XR-toast>
    <XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      loaded: true,
      addressList: [],
      deleteId: 0,
	  delAddress: false
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getAddressList()
  },
  methods: {
    goTo:function(url){
      this.$router.push(url)
    },
    setDefault: function(id){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/SetDefaultAddress",
        JSON.stringify({AddressId: id})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    edit: function(id){
      this.$router.push("/usercenter/addressedit?id="+id)
    },
    dele: function(id){
      this.deleteId = id
      this.open();
    },
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    getAddressList(){      
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetReceiveAddressList"
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        ths.loaded=false
        if(!res.IsSuccess){
          ths.$refs.XRPageTip.ShowEmpty(res.Msg)
        }else{            
          ths.$refs.XRPageTip.initTip()
          ths.addressList = res.Data
        }
      });
    },
    deleAddress(){
      this.dialog = false
      if(this.deleteId <=0){
        this.$refs.XRtoast.failed("请选择一条地址", true)
        return
      }
      this.$refs.XRtoast.load("删除中...")
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/DeleteReceiveAddress",
        JSON.stringify({receiveId: this.deleteId})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.success(res.Msg, true)
		  ths.delAddress = true
          ths.getAddressList()
        }
      });
    },
    setDefaulSuccess(){
      if(this.$route.query.redirecturl && !this.delAddress){
        this.$router.goBack()
      }else{	  
        if (!this.delAddress){	  
          this.$refs.XRtoast.load()		
		  this.delAddress = true
          this.getAddressList()		  
		}
      }
    }
  }
}
</script>
<style>
.address .address-list{ 
  background: #eee;
  overflow: hidden;
}
.address .address-item{
  margin: 10px 0; 
  padding: 0 8px;
  background: white;
}
.address .address-info{
  padding:15px 0;
}
.address .address-info .user{
  overflow: hidden;
}
.address .address-info .user .name{
  float: left;
}
.address .address-info .user .phone{
  float: left;
  padding-left: 20px;
}
.address .address-info .user .isDefault{
  float: right;
  color:red;
}
.address .address-info .addr{
  overflow: hidden;
  word-break:break-all;
}
.address .address-operator{
  padding: 15px 0;
  overflow: hidden;
  text-align: right;
}
.address .btn-edit-address,.btn-dele-address{
}
.address .btn-address-add{
  position: fixed;
  bottom: 60px;
  right: 20px;
  z-index: 9999;
}
.address .fa-jiahao{margin-bottom: 2px}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/address.vue